import React from 'react';

import Loading from 'client/components/Loading';

export default function ResultSubmitingMask({ show }) {
    return show && <Loading />;
}
